<template>
  <div class="sides-class" v-if="DetailAdv.id">
    <a
      :href="DetailAdv.redirect"
      target="_blank"
    >
      <img class="DetailAdv-img" :src="DetailAdv.img" alt />
      <div class="icon">广告</div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    DetailAdv: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.sides-class {
  max-height: 197px;
  overflow: hidden;
  margin-top: 16px;
  position: relative;
}

.DetailAdv-img {
  width: 100%;
  height: 197px;
  border-radius: 8px;
  z-index: 0;
  // margin-top: 16px;
}

.icon {
  position: absolute;
  bottom: 4px;
  right: 4px;
  z-index: 1;
  width: 44px;
  height: 26px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  line-height: 26px;
  text-align: center;
}
</style>
